import { ButtonComponent } from "@syncfusion/ej2-react-buttons";
import {
  FaAddressBook,
  FaEdit,
  FaPlus,
  FaRemoveFormat,
  FaTrashAlt,
} from "react-icons/fa";

const templateFooter = () => {
  return (
    <div
      style={{
        width: "100%",
        alignItems: "center",
        justifyContent: "space-between",
        display: "flex",
        flexDirection: "row",
      }}
    >
      <div style={{ flexDirection: "row", display: "flex" }}>
        <ButtonComponent
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "25px",
            width: "50x",
            height: "50px",
          }}
        >
          <FaPlus size="25px" />
        </ButtonComponent>
        <ButtonComponent
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "25px",
            width: "50x",
            height: "50px",
            marginLeft:"40px"
          }}
        >
          <FaEdit size="25px" />
        </ButtonComponent>
      </div>
      <ButtonComponent
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "25px",
          width: "50x",
          height: "50px",
        }}
      >
        <FaTrashAlt color="red" size="25px" />
      </ButtonComponent>
    </div>
  );
};
export default templateFooter;
